import React, { useRef, useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Blogs1 from "../assets/Blog1.webp";
import Blogs2 from "../assets/Blog2.webp";
import Blogs3 from "../assets/Blog3.webp";
import "../App.css";

const blogTypes = {
  "Housing Loan": { image: Blogs2, count: 6 },
  "Personal Loan": { image: Blogs3, count: 6 },
  "Business Loan": { image: Blogs1, count: 6 },
  "Vehicle Loan": { image: Blogs3, count: 6 },
  "Gold Loan": { image: Blogs1, count: 6 },
  "Loan Against Property": { image: Blogs1, count: 6 },
};

const blogs = Object.entries(blogTypes).flatMap(([title, { image, count }]) =>
  Array.from({ length: count }, (_, index) => ({
    id: `${title.toLowerCase().replace(/\s+/g, "-")}-${index + 1}`,
    image,
    title,
    description:
      "Our goal is to provide easy-to-use, transparent financial products the .....",
  }))
);

const categories = ["All Blogs", ...Object.keys(blogTypes)];

const AllBlogs = () => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  const [state, setState] = useState({
    activeFilter: "All Blogs",
    currentPage: 1,
    searchQuery: "",
  });

  const cardsPerPage = 6;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer || isMobile) return;

    let isDown = false,
      startX,
      scrollLeft;

    const handlers = {
      mousedown: (e) => {
        isDown = true;
        scrollContainer.style.cursor = "grabbing";
        startX = e.pageX - scrollContainer.offsetLeft;
        scrollLeft = scrollContainer.scrollLeft;
        e.preventDefault();
      },
      mouseleave: () => {
        isDown = false;
        scrollContainer.style.cursor = "grab";
      },
      mouseup: () => {
        isDown = false;
        scrollContainer.style.cursor = "grab";
      },
      mousemove: (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollContainer.offsetLeft;
        const walk = (x - startX) * 1.5;
        scrollContainer.scrollLeft = scrollLeft - walk;
      },
    };

    Object.entries(handlers).forEach(([event, handler]) => {
      scrollContainer.addEventListener(event, handler);
    });

    scrollContainer.style.cursor = "grab";

    return () => {
      Object.entries(handlers).forEach(([event, handler]) => {
        scrollContainer.removeEventListener(event, handler);
      });
    };
  }, [isMobile]);

  const updateState = (updates) =>
    setState((prev) => ({
      ...prev,
      ...updates,
    }));

  const handleFilterClick = (category) => {
    updateState({ activeFilter: category, currentPage: 1 });
  };

  const handleSearch = (e) => {
    if (e.key === "Enter" || e.type === "click") {
      updateState({ currentPage: 1 });
    }
  };

  const resetFilters = () => {
    updateState({ activeFilter: "All Blogs", searchQuery: "", currentPage: 1 });
  };

  const filteredBlogs = blogs
    .filter(
      (blog) =>
        state.activeFilter === "All Blogs" || blog.title === state.activeFilter
    )
    .filter((blog) => {
      if (!state.searchQuery) return true;
      const query = state.searchQuery.toLowerCase();
      return (
        blog.title.toLowerCase().includes(query) ||
        blog.description.toLowerCase().includes(query)
      );
    });

  const totalPages = Math.ceil(filteredBlogs.length / cardsPerPage);
  const currentCards = filteredBlogs.slice(
    (state.currentPage - 1) * cardsPerPage,
    state.currentPage * cardsPerPage
  );

  const renderBlogCard = (blog) => (
    <div key={blog.id} className="col-12 col-sm-6 col-lg-4">
      <div
        className="card h-100"
        style={{
          borderRadius: "1.5rem",
          background: "#E6EFFD",
          border: "none",
        }}
      >
        <img
          src={blog.image}
          className="card-img-top"
          alt={blog.title}
          style={{
            borderRadius: "1.25rem 1.25rem 0 0",
            objectFit: "cover",
            width: "100%",
            height: isMobile ? "14rem" : "18rem",
          }}
        />
        <div className="card-body p-3 p-md-4">
          <h5
            className="card-title bg-white rounded-5 d-inline-block px-2 py-2 mb-2"
            style={{
              color: "#0F62FE",
              fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
              border: "2px solid #0F62FE",
            }}
          >
            {blog.title}
          </h5>
          <p
            className="card-text"
            style={{
              fontSize: isMobile ? "0.85rem" : "0.95rem",
              color: "#4b4b4b",
            }}
          >
            {blog.description}
          </p>
          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-3 gap-2">
            <Link
              to="/blog-article-page"
              className="text-decoration-none d-flex fw-semibold align-items-center"
              style={{
                color: "#4b4b4b",
                fontSize: isMobile ? "13px" : "14px",
              }}
            >
              Read More{" "}
              <i
                className="fas fa-arrow-right ms-2"
                style={{ color: "#4b4b4b" }}
              ></i>
            </Link>
            <span
              className="text-muted small"
              style={{ fontSize: isMobile ? "11px" : "12px" }}
            >
              24 March, 2025
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
      (page) =>
        page === 1 ||
        page === totalPages ||
        (page >= state.currentPage - 1 && page <= state.currentPage + 1)
    );

    return (
      <nav aria-label="Blog pagination" className="my-4 my-lg-5">
        <ul className="pagination justify-content-center flex-wrap gap-2">
          <li className={`page-item ${state.currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link border-0"
              onClick={() =>
                updateState({ currentPage: Math.max(1, state.currentPage - 1) })
              }
              aria-label="Previous"
            >
              <i className="fas fa-chevron-left"></i>
            </button>
          </li>

          {pageNumbers.map((page) => (
            <li
              key={page}
              className={`page-item ${state.currentPage === page ? "active" : ""}`}
            >
              <button
                className="page-link border-0"
                onClick={() => updateState({ currentPage: page })}
              >
                {page}
              </button>
            </li>
          ))}

          <li
            className={`page-item ${
              state.currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link border-0"
              onClick={() =>
                updateState({
                  currentPage: Math.min(totalPages, state.currentPage + 1),
                })
              }
              aria-label="Next"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  if (!Array.isArray(blogs) || blogs.length === 0) {
    return (
      <div className="container min-vh-50 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary me-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h4 className="mb-0">Loading blogs...</h4>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid px-0 pe-0">
        <div className="container-fluid py-md-4">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <h1
                className="fw-semibold all-blog-text"
                style={{
                  fontSize: isMobile
                    ? "26px"
                    : isTablet
                    ? "32px"
                    : "36px",
                  marginTop: isMobile ? "1rem" : "2rem",
                }}
              >
                Blogs
              </h1>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="container mt-4 mt-md-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-8">
              <div className="d-flex flex-column flex-sm-row gap-3 align-items-center justify-content-between mb-4">
                <div className="w-100 position-relative">
                  <div
                    className="input-group rounded-pill overflow-hidden"
                    style={{ backgroundColor: "#ebebeb" }}
                  >
                    <span className="input-group-text border-0 bg-transparent ps-4">
                      <i
                        className="fas fa-search"
                        style={{ color: "#4B4B4B" }}
                      ></i>
                    </span>
                    <input
                      type="text"
                      className="form-control border-0 bg-transparent"
                      placeholder="Search blogs..."
                      value={state.searchQuery}
                      onChange={(e) =>
                        updateState({ searchQuery: e.target.value })
                      }
                      onKeyPress={handleSearch}
                      style={{ fontSize: isMobile ? "13px" : "14px" }}
                    />
                    <button
                      className="btn px-4 py-2 fw-semibold rounded-pill me-3 my-3"
                      style={{
                        color: "black",
                        backgroundColor: "#ffffff",
                        fontSize: isMobile ? "13px" : "14px",
                      }}
                      onClick={handleSearch}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Categories */}
        <div className="container mt-3 mt-lg-4">
          <div
            className="mx-auto category-scroll-wrapper"
            style={{ maxWidth: "1300px" }}
          >
            <div
              ref={scrollContainerRef}
              className={`d-flex flex-nowrap pb-2 gap-2 gap-md-4 scrollbar-hidden ${
                !isMobile ? "scroll-x-on-desktop" : "overflow-auto"
              }`}
              style={{ scrollBehavior: "smooth" }}
            >
              {categories.map((category) => (
                <button
                  key={category}
                  className="btn px-3 py-2 fw-semibold rounded-pill flex-shrink-0"
                  style={{
                    backgroundColor:
                      state.activeFilter === category ? "#0d6efd" : "#ebebeb",
                    color: state.activeFilter === category ? "white" : "black",
                    border: "none",
                    whiteSpace: "nowrap",
                    fontSize: isMobile ? "12px" : "14px",
                  }}
                  onClick={() => handleFilterClick(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Blog cards */}
        <div className="container mt-4 mt-lg-5">
          <div className="row g-4">
            {currentCards.length > 0 ? (
              currentCards.map(renderBlogCard)
            ) : (
              <div className="col-12 text-center py-5">
                <i className="fas fa-search fa-3x mb-3 text-muted"></i>
                <h3 className="mb-2">No blogs found</h3>
                <p className="text-muted">
                  Try adjusting your search or filter criteria
                </p>
                <button
                  className="btn btn-outline-primary mt-2"
                  onClick={resetFilters}
                >
                  Reset Filters
                </button>
              </div>
            )}
          </div>

          {renderPagination()}
        </div>
      </div>
    </>
  );
};

export default AllBlogs;
